/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState, useRef } from 'react';
import MainPageHeader from '../Components/MainPageHeader';
import DefineModel from './DefineModel/DefineModel';
import ISRTabs from '../Components/ISRTabs';
import { MODEL, RELATIONSHIPS, INPUT_PARAMETER, USER_INTERFACE, UI_MODEL } from '../ISRConstants';
import { TUpsertISRProjectDataModelsInput, TUpsertISRProjectDataModelsInput1 } from './DefineModel/model';
import { createProject, createUIMOdel, getISRProject, getUIModels, copyModel } from './DefineModel/ModelServices/ModalServices';
import AuthManager from 'Common/AuthManager';
import { toast } from 'Components/DesignSystem/Toast/useToast';
import _isEqual from 'lodash/isEqual';
import _cloneDeep from 'lodash/cloneDeep';
import { useISRContext } from '../Hooks/useISRContext';
import { TUIModel } from './UIBuilder/ui';
import { AppContext } from 'Context/AppContext';
import { TUIBuilder } from './UIBuilder/ui';
import UIBuilder from './UIBuilder/UIBuilder';
import CreateISRDialog from "../Components/CreateISRDialog";
import RulesComponent from './Rules/Rules';
import { SB3RuleContextProvider } from '../Components/Rules/SB3RuleContext';
import { useLocation, useNavigate } from "react-router";
import UIModelsModule1 from '../UI-Model-1/UIModelsModule1';
import { SB3Integrations } from '../Components/Integrations';
import CopyModal from 'Pages/GMS/ARS/Components/CopyModal';
import { suggestModelName } from 'Pages/GMS/ARS/Components/HelperClass';
// Toggle import removed - New UI Builder toggle is hidden

type TISRProjectProps = {
    isrId?: string;
    isrName?: string;
}

const ISRMainPage = ({isrId, isrName}: TISRProjectProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const appContext = useContext(AppContext);
    const isrContext = useISRContext();
    const initialModels: TUpsertISRProjectDataModelsInput = { project: { ISRName:  "", dataModels: [], fields: [], productCategories: [], connectors: [], id: '' }, rules: [], };
    const [projectId, setProjectId] = useState<string | null | undefined>('');
    
    const [uiModelProjectData, setUiModelProjectData] = useState<TUIModel>({ channel: appContext?.channelKey, industry: isrContext?.industryId ?? '', projectId: '', orientation: 'Grid', id: '', is_promoted: false} );
    const [uiBuilderProjectData, setUiBuilderProjectData] = useState<TUIBuilder>({ channel: appContext?.channelKey,industry: isrContext?.industryId ?? '', projectId: '', orientation: 'Grid', pages: [{pageName: 'New Page 1', formData: []}], id: '', config: {} });
    const initializeUIModel = { channel: appContext?.channelKey, industry: isrContext?.industryId ?? '', projectId: projectId, orientation: 'Grid', id: '', is_promoted : false};
    const [userProjectDataModels, setUserProjectDataModels] = useState<TUpsertISRProjectDataModelsInput>(initialModels);
    const [isPreviewAvailable, setIsPreviewAvailable] = useState<boolean>(false)

    const [doesISRProjectAPICalled, setDoesISRProjectAPICalled] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<number>(0);
    const isGuideDetail = Boolean(location.pathname.includes('/guide/'));
    const tabLabels =  [MODEL, RELATIONSHIPS, INPUT_PARAMETER, USER_INTERFACE, UI_MODEL];

    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [showLoaderUi, setShowLoaderUi] = useState<boolean>(true);
    const [loaderMessage, setLoaderMessage] = useState<string>('');
    const [showDialog, setShowDialog] = useState<boolean>(false);
    const [modelStatus, setModelStatus] = useState<string>('');
    const [widgetName, setWidgetName] = useState<string>('');
    const [isCurrentUserOwner, setIsCurrentUserOwner] = useState<boolean>(true);
    const [cloning, setCloning] = useState<boolean>(false);
    const [showCopyModal, setShowCopyModal] = useState<boolean>(false);
    const [copyModelName, setCopyModelName] = useState<string>('');
    const [hasDeletedRule, setHasDeletedRule] = useState<boolean>(false);

    // Ref to hold the UI Models table refresh function
    const uiModelsRefreshRef = useRef<(() => void) | null>(null);
 
    const openDialog = () => setShowDialog(true);
    const closeDialog = () => setShowDialog(false);
 
    // Callback to refresh both User Interface and UI Models sections after promotion
    const handlePromotionSuccess = () => {
        setHasDeletedRule(false);
        // Refresh User Interface section (UI Definition)
        fetchUIDefinitions(userProjectDataModels);
        // Refresh UI Models table
        if (uiModelsRefreshRef.current) {
            uiModelsRefreshRef.current();
        }
    };

    useEffect(() => { setProjectId(isrId);}, [isrId]);
    
    const handleTabClick = (index: number) => setActiveTab(index);

    const updateProjectDataModels = (
        setDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>,
        project: TUpsertISRProjectDataModelsInput
    ) => {
        setDataModels((prev: TUpsertISRProjectDataModelsInput) => {
            if (!project) {
                return prev;
            }
            const mergedProject = { ...prev.project, ...project };
            // Preserve locally-held inputParameters if the server response omits or clears them
            if (!mergedProject.inputParameters?.length && prev.project.inputParameters?.length) {
                mergedProject.inputParameters = prev.project.inputParameters;
            }
            return {
                ...prev,
                project: mergedProject,
            };
        });
    };

    useEffect(() => {
        if (appContext?.channelKey) {
            setUiModelProjectData((prevUiModel: any) => {
                return {
                    ...prevUiModel,
                    channel: appContext?.channelKey,
                    projectId: uiBuilderProjectData.projectId,
                    builderPages: {
                        pages: uiBuilderProjectData.pages,
                        config: uiBuilderProjectData.config
                    },
                };
            });
        }
    }, [uiBuilderProjectData, appContext?.channelKey]);

    useEffect(() => {
        if (doesISRProjectAPICalled) {
            setDoesISRProjectAPICalled(false);
            return;
        }
        let isMounted = true;
        const timerId = setTimeout(() => {
            if (isMounted) {
                // Live Guide models cannot be edited — skip auto-save
                // TODO(restore): live-model edit restriction temporarily lifted so the owner can edit live models
                // if (isGuideDetail && modelStatus === 'Live') return;
                if (doesISRProjectAPICalled) {
                    setDoesISRProjectAPICalled(false);
                    return;
                }
                const isEqual = _isEqual(isrContext?.networkUserProjectDataModels, userProjectDataModels);
                if (isEqual) return;
                createISRProject();
            }
        }, 1500);
        return () => {
            isMounted = false;
            clearTimeout(timerId);
        };
    }, [userProjectDataModels]);
    
    const createISRProject = async (isRuleUpdate: boolean = false) => {
        try {
            setShowLoader(true);
            setLoaderMessage('Saving changes...');
            const isrProject : TUpsertISRProjectDataModelsInput1 = {industry: isrContext?.industryId ?? '', channel: appContext?.channelKey, id: projectId ? projectId : isrId === "null" ? '' : isrId , project: userProjectDataModels.project, rules: []};
            const response = await createProject(isrProject, isGuideDetail);
            if (response === null) return;
            if (response?.done) {
                const { project_data  } = response;
                const project: TUpsertISRProjectDataModelsInput = project_data?.project;
                setProjectId( response?.project_data?.id ?? '');
                const areObjectsEqual = _isEqual(isrContext?.networkUserProjectDataModels.project, project);
                if (!areObjectsEqual) {
                    // Deep-clone the network snapshot so it does NOT share nested references with the
                    // working copy (userProjectDataModels). The debounced autosave compares the two with
                    // _isEqual; if they share references, in-place edits mutate both and the guard always
                    // reports "no change", silently skipping every save.
                    updateProjectDataModels(isrContext?.setNetworkUserProjectDataModels, _cloneDeep(project));
                    if (isrContext?.updateLocalState || isRuleUpdate) {
                        setDoesISRProjectAPICalled(true);
                        updateProjectDataModels(setUserProjectDataModels, project);
                    }
                }
            } else {
                toast.error(response?.message ?? '');
            }
        } catch (e) {
            console.log('Error', e);
        } finally {
            setShowLoader(false);
            isrContext?.setUpdateLocalState(false);
            setLoaderMessage('');
        }
    }

    useEffect(() => {
        let isMounted = true;
        const timerId = setTimeout(() => {
            if (isMounted) {
                if (uiModelProjectData.projectId === '') {
                    console.log('Project Id is missing ...');
                    return;
                }
                // if (uiModelProjectData?.pages[0]?.pageName === '') {
                //     console.log('A Page name is required');
                //     return;
                // }
                if (isrContext?.doesUIDefinitionAPICalled) {
                    isrContext?.setDoesUIDefinitionAPICalled(false);
                    return;
                }
                // if (uiModelProjectData?.pages[0]?.pageName === '') {
                //     console.log('A Page name is required');
                //     return;
                // }
                // if (isrContext?.doesUIDefinitionAPICalled) {
                //     isrContext?.setDoesUIDefinitionAPICalled(false);
                //     return;
                // }                
                createUIDefinition();
            }
        }, 5000);
        return () => {
            isMounted = false;
            clearTimeout(timerId);
        };
    }, [uiModelProjectData]);

    const createUIDefinition = async () => {
        try {
            setShowLoader(true);
            setLoaderMessage('Saving changes...');
            //console.log(uiModelProjectData)
            const response = await createUIMOdel(uiModelProjectData);
            if (response === null) return;
            if (response?.done) {
                const uiDefinition: TUIModel = response?.data;
                const areObjectsEqual = _isEqual(uiModelProjectData, response?.data);
                if (!areObjectsEqual) {
                    setUiModelProjectData(uiDefinition);
                    setIsPreviewAvailable(uiDefinition?.isPreviewAvailable ?? false)
                }
            } else {
                toast.error(response?.message ?? '');
            }
        } catch (e) {
            console.log('Error', e);
        } finally {
            setShowLoader(false);
            setLoaderMessage('');
        }
    }

    useEffect(() => {
        if (isrId ===  'null') return;
        setProjectId(isrId);
        fetchISRProjects();
    }, [isrContext?.industryId]);


    const fetchISRProjects = async () => {
        try {
            setDoesISRProjectAPICalled(true);
            setShowLoader(true);
            setLoaderMessage(`Fetching ${isrName} project ...`);
            const responseData = await getISRProject(isrId ?? '');
            if (responseData?.done) {
                const { data } = responseData;
                //console.log(data?.id)
                setProjectId(data?.id ?? '');
                const normalizedData = data ? { ...data, project: { ...data.project, id: data.id ?? '' } } : initialModels;
                setUserProjectDataModels(normalizedData);
                // Deep-clone so the baseline snapshot is independent of the working copy (see the
                // matching clone in createISRProject). Sharing the same object would make the
                // autosave _isEqual guard always true and skip every save.
                isrContext?.setNetworkUserProjectDataModels(_cloneDeep(normalizedData) ?? isrContext?.initialUserProjectDataModels);
                if (isGuideDetail) {
                    setModelStatus(data?.status ?? '');
                    setWidgetName(data?.widgetName ?? '');
                    const currentUserId = AuthManager.getAuthUser()?.profile?.id;
                    setIsCurrentUserOwner(!data?.createdBy || !currentUserId || data.createdBy === currentUserId);
                }
                await fetchUIDefinitions(normalizedData);
            } else {
               // setUserProjectDataModels(initialUserProjectDataModels);
            }
        } catch (error) {
            console.error('Error fetching ISR projects:', error);
            setUserProjectDataModels(initialModels);
        } finally {
            setShowLoader(false);
            setLoaderMessage('');
        }
    }

    const handleEditName = (value: string) => {
        setUserProjectDataModels((prevConfig) => ({ ...prevConfig, project: {...prevConfig.project, ISRName: value}}));
        closeDialog();
    };

    const fetchUIDefinitions = async (data?: any) => {
        try {
            setShowLoaderUi(true);
            isrContext?.setDoesUIDefinitionAPICalled(true);
            const id = data?.id ?? '' //userProjectDataModels?.project?.id ?? '';
            if (id) {
                const responseData = await getUIModels(id ?? '');
                if (responseData?.done) {
                    setUiModelProjectData(responseData?.data ?? initializeUIModel);
                    setIsPreviewAvailable(responseData?.data?.isPreviewAvailable ?? false)
                }
            }

        } catch (error) {
            console.error('Error fetching UI Model', error);
           // setUserProjectDataModels(initialUserProjectDataModels);
        } finally {
            setShowLoaderUi(false);
        }
    }
    // TODO(restore): live-model edit restriction temporarily lifted so the owner can edit live models
    // const isLiveGuideModel = isGuideDetail && modelStatus === 'Live';
    const isLiveGuideModel = false;

    const openCloneModal = () => {
        if (!projectId) return;
        setCopyModelName(suggestModelName(userProjectDataModels.project.ISRName ?? 'Model', []));
        setShowCopyModal(true);
    };

    const closeCloneModal = () => {
        setShowCopyModal(false);
        setCopyModelName('');
    };

    const handleClone = async () => {
        if (!projectId || cloning) return;
        const name = copyModelName.trim();
        if (!name) {
            toast.warning('Please enter a model name');
            return;
        }
        setCloning(true);
        try {
            const response = await copyModel(projectId, name);
            if (response?.data?.done) {
                const cloned = response.data.data;
                const clonedId = cloned?.id ?? '';
                const clonedName = cloned?.project?.ISRName ?? clonedId;
                setShowCopyModal(false);
                setCopyModelName('');
                toast.success('Model cloned successfully');
                navigate(`/gms/guide/main/${encodeURIComponent(clonedName)}/${clonedId}`);
            } else {
                // Keep the modal open so the user can correct the name (e.g. duplicate)
                toast.error(response?.data?.message || 'Failed to clone model');
            }
        } catch {
            toast.error('Failed to clone model');
        } finally {
            setCloning(false);
        }
    };

    return (
        <React.Fragment>
            {/*
              Sticky pins at the scroll container's PADDING edge, and Layout's <main> has
              `pt-3` — so at `top-0` the header stuck 12px down and whatever scrolled
              under it showed through that strip (the UI Model editor's "← name … Preview"
              row). `-top-3` pins it at <main>'s top edge; `-mt-3 pt-3` cancel each other
              at rest, so nothing moves until it sticks. `z-30`, not `z-20`: the editor's
              « » panel toggles are `z-20` and, later in the DOM, painted over the title.
            */}
            <div id="isr-fixed-header" className="tw-sticky tw--top-3 tw--mt-3 tw-pt-3 tw-z-30 tw-bg-surface">
                <MainPageHeader
                    componentId="isr-page-header"
                    isrName={userProjectDataModels.project.ISRName ?? ''}
                    showLoader={showLoader}
                    loaderMessage={loaderMessage}
                    productId={projectId ? projectId : isrId === "null" ? '' : isrId}
                    id={projectId}
                    onEditClick={() => openDialog()}
                    isGuideDetail={isGuideDetail}
                    onPromotionSuccess={handlePromotionSuccess}
                    modelStatus={isGuideDetail ? modelStatus : undefined}
                    widgetName={isGuideDetail ? widgetName : undefined}
                    isCurrentUserOwner={isGuideDetail ? isCurrentUserOwner : undefined}
                    onClone={isGuideDetail ? openCloneModal : undefined}
                    cloning={isGuideDetail ? cloning : undefined}
                    hasDeletedRule={hasDeletedRule}
                />
                <div id="isr-tabs-wrapper" className='tw-flex tw-justify-center tw-border-b tw-border-t tw-border-solid tw-border-edge tw-mb-3'>
                    <ISRTabs
                        id="isr-tabs"
                        tabLabels={tabLabels}
                        activeTab={activeTab}
                        onTabClick={handleTabClick}
                        showLoaderUi={showLoaderUi}
                    />
                </div>
            </div>
            {showCopyModal ? <CopyModal
                id="guide-clone-model-modal"
                showModal={showCopyModal}
                closeModal={closeCloneModal}
                onConfirm={handleClone}
                modelName={copyModelName}
                setCopyModelName={setCopyModelName}
                isCopying={cloning}
            /> : null}
            {activeTab === 0 ?
                <div className={isLiveGuideModel ? 'tw-relative tw-pointer-events-none tw-select-none tw-opacity-60' : ''}>
                    <DefineModel
                        id="isr-define-model"
                        userProjectDataModels={userProjectDataModels}
                        setUserProjectDataModels={setUserProjectDataModels}
                        createISRProject={createISRProject}
                        /* FIRST load only. `showLoader` is also true while saving, and a
                           skeleton on every autosave would throw away the user's place in
                           the explorer; once the project has an id there is real content to
                           keep showing, so the header message carries saves on its own. */
                        loading={showLoader && !userProjectDataModels?.project?.id}
                    />
                </div>
            : null}
            {activeTab === 1 ?
                <div className={isLiveGuideModel ? 'tw-relative tw-pointer-events-none tw-select-none tw-opacity-60' : ''}>
                    <SB3RuleContextProvider>
                        <RulesComponent id="isr-rules" projectId={projectId} onRuleDeleted={() => setHasDeletedRule(true)} />
                    </SB3RuleContextProvider>
                </div>
            : null}
            {activeTab === 2 ?
                <div className={isLiveGuideModel ? 'tw-relative tw-pointer-events-none tw-select-none tw-opacity-60' : ''}>
                    <SB3Integrations
                        id="isr-integrations"
                        projectId={projectId ?? ''}
                        userProjectDataModels={userProjectDataModels}
                        setUserProjectDataModels={setUserProjectDataModels}
                    />
                </div>
            : null}
            {activeTab === 3 && !showLoaderUi ?
                <UIBuilder 
                    id="isr-ui-builder"
                    isPreviewAvailable={isPreviewAvailable} 
                    userProjectDataModels={userProjectDataModels} 
                    builderData={uiModelProjectData} 
                    uiModelProjectData={uiBuilderProjectData} 
                    projectId={isrContext?.networkUserProjectDataModels?.id ?? ''} 
                    modelId={uiModelProjectData?.projectId ?? ''} 
                    setUiModelProjectData={setUiBuilderProjectData} 
                    isPromoted={uiModelProjectData.is_promoted}
                /> 
            : null}
            {activeTab === 4 ? (
              <div className="tw-flex tw-flex-col tw-h-full">
                {/* Content Area */}
                <div className="tw-flex-1 tw-overflow-auto">
                  <UIModelsModule1
                    channelId={appContext?.channelKey}
                    projectId={isrContext?.networkUserProjectDataModels?.id ?? ''}
                    userId={isrContext?.networkUserProjectDataModels?.created_by ?? ''}
                    userProjectDataModels={userProjectDataModels}
                    industryId={isrContext?.industryId ?? ''}
                    selectedParty={appContext?.selectedParty}
                    refreshRef={uiModelsRefreshRef}
                    onFreestyleUIModelChange={(hasFreestyle) =>
                      setUserProjectDataModels((prev) => ({ ...prev, has_freestyle_ui_model: hasFreestyle }))
                    }
                  />
                </div>
              </div>
            ) : null}
            {showDialog ? 
                <CreateISRDialog
                    id="update-isr-model-name"
                    dialogHeader={'Edit Model Name'} 
                    labelName={'Model Name'} 
                    onClose={closeDialog} 
                    onSubmodelFieldSubmit={handleEditName} 
                    showCancelButton={false} 
                    actionLabel={'Save'}
                    value={userProjectDataModels.project.ISRName}  
                /> 
            : null}

        </React.Fragment>
    );
}

export default ISRMainPage;
